var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2865 3H11.715C7.155 3 4.5 5.67 4.5 10.245V25.74C4.5 30.39 7.155 33 11.715 33H24.2865C28.92 33 31.5 30.39 31.5 25.74V10.245C31.5 5.67 28.92 3 24.2865 3Z",
    fill: "#0054E6",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 23.61H23.88C24.4785 23.67 24.93 24.18 24.93 24.795C24.93 25.3935 24.4785 25.905 23.88 25.965H12.12C11.67 26.025 11.235 25.8 10.995 25.425C10.755 25.035 10.755 24.54 10.995 24.165C11.235 23.775 11.67 23.565 12.12 23.61ZM23.88 16.7685C24.525 16.7685 25.05 17.295 25.05 17.94C25.05 18.585 24.525 19.11 23.88 19.11H12.12C11.4735 19.11 10.95 18.585 10.95 17.94C10.95 17.295 11.4735 16.7685 12.12 16.7685H23.88ZM16.6035 9.97498C17.25 9.97498 17.775 10.5 17.775 11.1435C17.775 11.805 17.25 12.33 16.6035 12.33H12.12C11.4735 12.33 10.95 11.805 10.95 11.16C10.95 10.515 11.4735 9.98998 12.12 9.98998V9.97498H16.6035Z",
    fill: "#0054E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ec051dff57651d6676026db43cea4927.svg";
export { ForwardRef as ReactComponent };